<template>
    <div v-if="status !== 'loading'">
        <checkout-form
                v-if="checkout_form_data.payment_found"
                :form_data="checkout_form_data"
                :submit="submit"
        ></checkout-form>
        <kt-panel v-else>
            <kt-panel-body>
                <p class="font-weight-bolder text-center" :style="{fontSize: '15px'}">
                    {{ $t('message.payment_page_not_found') }}
                </p>
            </kt-panel-body>
        </kt-panel>
    </div>
    <loader v-else></loader>
</template>

<script>
    import checkoutForm from "./components/checkout-form"
    import Loading from '@/components/custom/loading'
    import {mapGetters} from "vuex";
    import { BASE_PATH } from '@/common/config'
    import { KTApp } from '@/plugins/core/app'
    import { pardakhtShakhsiService } from '@/common/api.service'
    import $ from "jquery";

    export default {
        name: "Checkout",

        components: {
            'checkout-form': checkoutForm,
            'loader': Loading
        },
        computed: {
            ...mapGetters('pardakhtShakhsi', ['checkout_form_data', 'status']),
            ...mapGetters('pardakhtShakhsi', ['direct_form_data']),
        },

        data() {
            return {
                'tracking_code': this.$route.params.tracking_code
            }
        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
                vm.$store.dispatch('pardakhtShakhsi/checkoutData', vm.tracking_code)
            })
        },
        methods: {
            submit(e) {
                switch (e) {
                    case 0:
                        b_back(this)
                        break
                    case 1:
                        b_pay(this)
                        break
                }

                function b_back(_this){
                    _this.direct_form_data.amount = _this.NumericFormat(_this.checkout_form_data.pay_amount) -
                        _this.NumericFormat(_this.checkout_form_data.payer_wage)
                    _this.direct_form_data.payer_name = _this.checkout_form_data.payer_name
                    _this.direct_form_data.payer_email = _this.checkout_form_data.payer_email
                    _this.direct_form_data.payer_phone_number = _this.checkout_form_data.payer_phone_number
                    _this.direct_form_data.payer_description = _this.checkout_form_data.payer_description
                    //console.log(_this.direct_form_data)

                    _this.$router.push({
                        name: 'direct_pay',
                        params: {
                          username: _this.checkout_form_data.username
                        },
                    });
                }
                function b_pay(_this){
                    window.location = BASE_PATH + '/pardakht-shakhsi/pay/' + _this.checkout_form_data.tracking_code;
                }
                // let btn = $('#submit_btn')
                // KTApp.progress(btn)
                //
                // let params = this.$store.getters['pardakhtShakhsi/direct_form_data']
                //
                // pardakhtShakhsiService.newDirectPay(params).then(response => {
                //     this.$router.push({
                //         name: 'direct_checkout',
                //         params: {
                //             tracking_code: response.data.data.tracking_number
                //         }
                //     });
                // })
                //     .catch(({response}) => {
                //         if(response.data) {
                //             form.validate().showErrors(response.data.data)
                //         }
                //         this.showMsg(form, 'danger', response.data.message)
                //     })
                //     .finally(() => {
                //         KTApp.unprogress(btn)
                //     })
            },
            NumericFormat(value) {
                if (isNaN(value))
                    return value.replace(',', '')
                else
                    return value
            }
        },
    }
</script>

<style scoped>

</style>